var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectBalancingResource } from "../../../../../../balancingSelectors/selectBalancingResources";
import { IdStyles } from "../../../../../../less/IdStyles";
import { ReplacementLoca } from "../../../../../../utils/i18n/ReplacementLoca";
import { utilLoca } from "../../../../../../utils/i18n/utilLoca";
import { utilNumber } from "../../../../../../utils/utilNumber";
import { actionBeginBuyWithGoldProcess } from "../../../../../buy-with-gold/actionBuyWithGold";
import { Icon } from "../../../../../generic/icon/Icon";
import { actionShowMeQuestTaskEarnResources } from "../../../../../show-me/actionShowMe";
import { ButtonQuestShowMe } from "../ButtonQuestShowMe";
import { getQuestIcon } from "../getQuestIcon";
import { QuestSkipButton } from "../QuestSkipButton";
import { QuestTask } from "../QuestTask";
export var _QuestTaskEarnResource = function (props) {
    var className = props.className, tasks = props.tasks, questInfoTasks = props.questInfoTasks, quest = props.quest, onTrySkip = props.onTrySkip, onClickShowMe = props.onClickShowMe;
    var task = tasks;
    var list = task.map(function (value) {
        var requiredResource = selectBalancingResource(value.resourceId);
        var requiredInfoTask = questInfoTasks.find(function (val) { return val.index === value.index; });
        var currentResourceAmount = requiredInfoTask.amount || 0;
        var taskCompleted = currentResourceAmount >= value.amount;
        var locaReplacements = new Map([
            [ReplacementLoca.amount, utilNumber.format(value.amount)],
            [
                ReplacementLoca.target,
                requiredResource ? utilLoca.get(requiredResource.locaKey) : "",
            ],
        ]);
        var iconName = getQuestIcon(requiredResource.name);
        var icon = React.createElement(Icon, { icon: iconName, styleId: IdStyles.IconExtraLarge });
        var taskProps = {
            currentAmount: currentResourceAmount,
            icon: icon,
            locaKey: value.locaKey,
            locaReplacements: locaReplacements,
            requiredAmount: value.amount,
            taskCompleted: taskCompleted,
        };
        var skipButtonProps = {
            currentAmount: currentResourceAmount,
            onTrySkip: onTrySkip,
            questId: quest.id,
            requiredAmount: value.amount,
            skipCost: value.skipCost,
            taskCompleted: taskCompleted,
            taskIndex: value.index,
        };
        return (React.createElement(QuestTask, __assign({ key: value.locaKey + "_" + icon }, taskProps),
            React.createElement(QuestSkipButton, __assign({}, skipButtonProps)),
            React.createElement(ButtonQuestShowMe, { onClick: function () { return onClickShowMe(value); }, questTask: value, taskCompleted: taskCompleted })));
    });
    return (React.createElement("div", { key: "earnResource", className: className }, list));
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClickShowMe: actionShowMeQuestTaskEarnResources,
        onTrySkip: actionBeginBuyWithGoldProcess,
    }, dispatch);
};
export var QuestTaskEarnResource = connect(undefined, mapDispatch)(_QuestTaskEarnResource);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/questTaskEarnResource/QuestTaskEarnResource.tsx
// module id = 2669
// module chunks = 3